import logoTypeSpec from '../images/spec/logoTypeSpec.png';
import backgroundSpec from '../images/spec/backgroundSpec.png';
import contrastColorSpec from '../images/spec/contrastColorSpec.png';
import thumbnailKlydosSpec from '../images/spec/thumbnailKlydosSpec.png';
import { COLLECTION_DESCRIPTION_LIMIT } from './textFieldsLimitations';
import { MAX_STRIKE_DURATION_SECONDS } from './audio';

export const DISE_SPEC = 'Display Seconds';
export const PUBLICATION_STATUS_SPEC = `Private – 
A Private Klydo will not appear in user feeds or search results (once the Klydo App is available). 
A Klydo set to Private can later be changed to Public.
Public – 
A Public Klydo will appear in user feeds and search results (once the Klydo App is available). 
Please Note: A Klydo set to Public cannot be added to a Collection.
Once a Klydo is set to Public, it cannot be changed back to Private.`;
export const LOGO_FADE_SPEC = `Collection logo fades by default after 5 seconds.
Disabling this feature permanently displays it.`;
export const COLLECTION_FIELDS_SPEC = `Currently this feature is available only in collections.`;

export const CHIME_SPEC = `Format: MP3 or WAV\nRecommended duration is 15–20 seconds. Should not exceed 30 seconds.`;

export const STRIKE_SPEC = `Format: MP3 or WAV\nRecommended duration is 2–${MAX_STRIKE_DURATION_SECONDS} seconds. Should not exceed ${MAX_STRIKE_DURATION_SECONDS} seconds.`;

export const ALARM_SPEC = `Format: MP3 or WAV\nRecommended duration is 15–20 seconds. Should not exceed 40 seconds.`;

export const THUMBNAIL_FRAME_SPEC = `The still frame that represents your Klydo wherever it is not animating.
Pick any frame of your loop, or leave it automatic and we will choose one for you.`;

export const COLLECTION_COVER_SPEC = `Cover Image Requirements:
• Size: 2000 × 2000 px (1:1 aspect ratio)
• Format: JPG or PNG
• Bit Depth: Min 8-bit (JPG), 24-bit (PNG)
• Must include collection title text, centered vertically and horizontally
• Title-safe zone: Keep all critical elements within 90% of frame
• Will display with rounded corners (radius ≈ width ÷ 3)
• No visible compression artifacts`;

export const COLLECTION_LOGOTYPE_SPEC = `Logotype Requirements:
• Size: 1000 × 300 px, 300 dpi
• 1000 px width (tightly cropped)
• Format: PNG (original)
• Content: Text-based logo
• Important: Logo should extend to edges without 
extra whitespace or padding around boundaries
• Must match collection's aesthetic style`;

export const COLLECTION_LOGO_SPEC = `Logo Symbol Requirements:
• Size: 1000 × 1000 px
• Format: Transparent PNG, 24-bit minimum
• Color Mode: RGB
• Color: Monochromatic (white)
• Style: Standalone mark
• Must remain legible and visually balanced when scaled down`;

export const COLLECTION_BACKGROUND_SPEC = `Background Image Requirements:
• Size: 2000 × 2000 px (1:1 aspect ratio)
• Format: JPG or PNG
• Bit Depth: Min 8-bit (JPG), 24-bit (PNG)
• Must match cover's style and theme
• Ample white/neutral space in center for text overlays
• Must remain legible with overlaid interface elements
• Provide textless version for adaptability`;

export const COLLECTION_DESCRIPTION_SPEC = `Description Requirements:
• Character Limit: ${COLLECTION_DESCRIPTION_LIMIT} (including spaces)
• Tone: Thematic and marketing-driven
• Should align with the visual style of the collection
• Keywords/tags recommended for search and categorization`;

export const COLLECTION_THUMBNAIL_KLYDOS_SPEC =
  'Select up to 6 Klydos to display in your Collection thumbnail';

export const COLLECTION_SCENE_SPEC =
  'Select a scene to display your Collection on the product page';

export const AFFILIATE_NOT_READY_SPEC =
  'Your Klydoclock Bundle is still being prepared. This can take up to an hour after going live.';

export const LOGO_TYPE_SPEC_IMAGE = logoTypeSpec;
export const BACKGROUND_SPEC_IMAGE = backgroundSpec;
export const CONTRAST_COLOR_SPEC_IMAGE = contrastColorSpec;
export const SELECT_6_KLYDOS_SPEC_IMAGE = thumbnailKlydosSpec;
